import { createSlice } from '@reduxjs/toolkit'
import { archiveSurveyTemplateApi, createSurveyTemplate, deleteSurveyTemplateApi, editSurveyTemplate, getSurveyByIdApi, getSurveyList } from './apis'
import { notification } from '../../../components/Notifications'
import { notifyError } from '../../../utils/notifyError'
import { type ISurveyTemplateListResponse } from '../../../models/SurveyTemplate'

export interface SurveySlice {
  surveyListLoading: boolean
  surveyList: ISurveyTemplateListResponse | null

  deleteLoading: boolean
  archiveLoading: boolean
  loading: boolean
}

const initialState: SurveySlice = {

  surveyListLoading: false,
  surveyList: null,
  deleteLoading: false,
  archiveLoading: false,
  loading: false
}

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    resetState: (state) => {
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSurveyList.pending, (state) => {
        state.surveyListLoading = true
      })
      .addCase(getSurveyList.fulfilled, (state, action) => {
        state.surveyListLoading = false
        state.surveyList = action.payload
      })
      .addCase(getSurveyList.rejected, (state, action) => {
        state.surveyListLoading = false
        notifyError(action.payload, { fallbackMessage: 'Failed to load surveys. Please try again.' })
      })
      // GET SURVEY BY ID
      .addCase(getSurveyByIdApi.pending, (state) => {
        state.surveyListLoading = true
      })
      .addCase(getSurveyByIdApi.fulfilled, (state, action) => {
        state.surveyListLoading = false
      })
      .addCase(getSurveyByIdApi.rejected, (state, action) => {
        state.surveyListLoading = false
      })

      // Delete SURVEY
      .addCase(deleteSurveyTemplateApi.pending, (state) => {
        state.deleteLoading = true
      })
      .addCase(deleteSurveyTemplateApi.fulfilled, (state, action) => {
        state.deleteLoading = false
        if (state.surveyList) {
          state.surveyList.data = state.surveyList?.data.filter((surveyList) => surveyList.data.templateId !== action.meta.arg.urlId)
        }
        notification('Successfully deleted', { variant: 'success', subTitle: action.payload.message })
      })
      .addCase(deleteSurveyTemplateApi.rejected, (state, action) => {
        state.deleteLoading = false
      })

      // Archive SURVEY
      .addCase(archiveSurveyTemplateApi.pending, (state) => {
        state.archiveLoading = true
      })
      .addCase(archiveSurveyTemplateApi.fulfilled, (state, action) => {
        state.archiveLoading = false
        if (state.surveyList) {
          state.surveyList.data = state.surveyList?.data.filter((surveyList) => surveyList.data.templateId !== action.meta.arg.urlId)
        }
        notification('Successfully archived', { variant: 'success', subTitle: action.payload.message })
      })
      .addCase(archiveSurveyTemplateApi.rejected, (state) => {
        state.archiveLoading = false
      })

      // Create Survey
      .addCase(createSurveyTemplate.pending, (state) => {
        state.loading = true
      })
      .addCase(createSurveyTemplate.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(createSurveyTemplate.rejected, (state) => {
        state.loading = false
      })

      // Update Survey
      .addCase(editSurveyTemplate.pending, (state) => {
        state.loading = true
      })
      .addCase(editSurveyTemplate.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(editSurveyTemplate.rejected, (state, action) => {
        state.loading = false
        notification(action.payload?.response?.data?.error?.schema[0], { variant: 'error' })
      })
  }
})

export const {
  resetState

} = surveySlice.actions
export default surveySlice.reducer
